import { memo } from "react";
import { Redirect, Route } from "react-router-dom";
import { Routes } from "../../../../const";
import useAuth from "../../../hooks/useAuth";

const AuthRoute = ({
  component: Component, location, condition, ...rest
}) => {

  const auth = useAuth()

  return (
    <Route {...rest}
      render={props =>
        auth
          ? <Component {...props} />
          : <Redirect to={{ pathname: Routes.SignIn, state: { from: location } }} />}
    />
  )
}
export default memo(AuthRoute);